import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent implements OnInit {

  public whitelabel: string
  public whitelabelURL: string = 'https://cubosgeneralstorage.blob.core.windows.net/whitelabel-storage/'

  private _returnUrl: string;

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this._returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'] || '/';
  }

  ngAfterViewInit() {
    this.whitelabel = localStorage.getItem('whitelabel')
  }


  public navigateToLogin() {
    this.router.navigate(['/auth/login']);
  }

}
